import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=4b4831a3&scoped=true&"
var script = {}
import style0 from "./Caption.vue?vue&type=style&index=0&id=4b4831a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4831a3",
  null
  
)

export default component.exports